import React from 'react';
import {Col, Row, Container, Button} from 'react-bootstrap';

const BCTerms = (props) =>{
    const {close} = props;
    return (
        <Container>
            <Row>
                <Col xs={12} lg={8} className="p-3 bg-white my-5">
                    <p className="">Situația înscrierii la Biroul de Credit poate fi obtinuță prin Conso dacă urmatoarele condiții sunt îndeplinite simultan:</p>
                    <ul className="">
                        <li>deschizi gratuit un cont Conso</li>
                        <li>înregistrezi o solicitare de credit validă în contul Conso în ultimele 7 zile</li>
                        <li>procedura de autentificare la Biroul de Credit este finalizată cu succes</li>
                        <li>nu ai solicitat un alt raport de credit prin Conso în ultimele 3 luni</li>
                    </ul>

                    <p className="font-weight-bold">Primul pas constă în solicitarea unei oferte de credit prin Conso, apăsând butonul Solicită Ofertă.</p>

                    <p>Din motive de securitate, accesul la acest serviciu poate fi restricționat de catre Conso în cazul unor tentative nereușite de autentificare la Biroul de Credit pentru a proteja datele personale ale utilizatorilor.</p>
                    <Button onClick={close}>Închide</Button>
                </Col>
            </Row>
        </Container>
    );
}

export default BCTerms;